import Spinner from "./Spinner.vue";
export { Spinner };
export default Spinner;
